import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {FontList} from '../FontList';
import {Detector} from '../Detector';
import {AppService} from '../app.service';
import {CardStyle, StyleText} from '../CardDesigner/CardSave';

declare let $: any;
declare let Konva: any;
declare let window: any;

@Component({
  selector: 'card-designer-mobile',
  templateUrl: './cardDesignerMobile.component.html',
  styleUrls: ['./cardDesignerMobile.component.css', '../app.component.css']
})
export class CardDesignerMobileComponent implements OnInit, OnDestroy {
  cardBackList = [
    {id: 0, src: "assets/0Hollow.png", main: '#ffffff', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 1, src: "assets/1Hollow.png", main: '#56caf5', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 2, src: "assets/2Hollow.png", main: '#bd202d', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 3, src: "assets/3Hollow.png", main: '#bdaf97', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 4, src: "assets/4Hollow.png", main: '#eb2128', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 5, src: "assets/5Hollow.png", main: '#00a64d', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 6, src: "assets/6Hollow.png", main: '#096e85', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 7, src: "assets/7Hollow.png", main: '#262a5e', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 8, src: "assets/8Hollow.png", main: '#eb3131', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 9, src: "assets/9Hollow.png", main: '#eb3131', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 10, src: "assets/10Hollow.png", main: '#242a5c', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 11, src: "assets/11Hollow.png", main: '#096e85', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 12, src: "assets/12Hollow.png", main: '#00a64d', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 13, src: "assets/13Hollow.png", main: '#b30000', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 14, src: "assets/14Hollow.png", main: '#527800', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 15, src: "assets/15Hollow.png", main: '#9a00bd', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 16, src: "assets/16Hollow.png", main: '#0068b8', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 17, src: "assets/17Hollow.png", main: '#00a8a5', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 18, src: "assets/18Hollow.png", main: '#ab0349', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 19, src: "assets/19Hollow.png", main: '#bd9a00', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 20, src: "assets/20Hollow.png", main: '#02bd85', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 21, src: "assets/21Hollow.png", main: '#9c3721', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 22, src: "assets/22Hollow.png", main: '#2b2b6e', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 23, src: "assets/23Hollow.png", main: '#fabb55', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 24, src: "assets/24Hollow.png", main: '#472f66', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 25, src: "assets/25Hollow.png", main: '#fabc8c', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 26, src: "assets/26Hollow.png", main: '#5a5a5c', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 27, src: "assets/27Hollow.png", main: '#307369', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 28, src: "assets/28Hollow.png", main: '#c2151b', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 29, src: "assets/29Hollow.png", main: '#00548c', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 30, src: "assets/30Hollow.png", main: '#005494', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 31, src: "assets/31Hollow.png", main: '#c9121b', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 32, src: "assets/32Hollow.png", main: '#376e6c', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true},
    {id: 33, src: "assets/33Hollow.png", main: '#555459', hwheel: [], swheel: [], lwheel: [], updateWheels: false, origBack: '', allowImage: true}
  ];
  showBackOptions = false;
  cardBackHeight = 0;
  previewedCard = '';
  originalCard = null;
  hasMadeStage: boolean = false;
  stage: any = null;
  runOverwrite = false;
  snapshotDefer = null;
  tempImageData = null;


  layer: any = null;
  imageSave: any = null;
  groupSave: any = null;
  fileUploading: any = null;
  resizeImageData: any = null;
  imageDefer = null;
  drawCanvasDefer = null;

  canvasHeight: number = 0;
  canvasWidth: number = 0;

  d: Detector = null;

  cbData: any = null;
  cbOriginalData: any = null;
  cbImgData: any = null;
  cbImgData1: any = null;
  cbChangeCtx: any = null;
  colorVal = 30;

  hueSlider = 180;
  satSlider = 180;
  lumSlider = 180;
  colorTest = '#ffffff';

  updatePreviewTimer = null;
  runningUpdate = false;
  processingChange = false;

  inFormatMode = false;
  inCropMode = false;
  subscription = null;
  cardBackColor = "";

  generatedPreviewImage = null;

  cropCornersSize = 32;

  itemWithResize = null;
  runningEdit: boolean = false;


  constructor(public app: AppService, private zone: NgZone) {
    this.d = new Detector();
    this.app.fonts = new FontList();
    this.app.fonts.fontList.filter((font) => {
      font.allowed = this.d.detect(font.name);
      return font.allowed;
    });
    console.log("In card designer constructor, changing card back");
    this.app.selectedCardBack = this.cardBackList[0];
    this.resetAllValuesToDefault();
    if (this.app.designerSub !== null) {
      this.app.designerSub.unsubscribe();
    }
    this.app.designerSub = this.app.broadcaster.subscribe((value) => {
      this.broadCastHandle(value);
    });
  }

  expandTabClicked() {
    console.log("Expand tab clicked");
    this.showBackOptions = !this.showBackOptions;
  }

  showColorInfo() {
    this.app.errorText = "Using the 'Click Color' button allows you to click a color in the canvas below to change the background color.";
    $('#errorModal').modal('show');
  }

  changeViewMode(mode: number) {
    console.log("Change view mode: ", mode);
    if (mode === 1) {
      if (this.app.selectedImage === null) {
        alert("Please add an image to view a preview.");
        return;
      } else if (this.app.selectedCardBack.id === 0) {
        alert("Please select a card back to view the preview.");
        return;
      }
    }
    this.app.viewMode = mode;
    if (mode === 1) {
      this.generatedPreviewImage = null;
      setTimeout(() => {
        this.createPreviewImage(true);
        // this.setCardPreview();
      }, 300);
    } else {

    }
  }

  getViewModeButtonDesign(mode: number) {
    if (this.app.viewMode === mode) {
      return {'background-color': '#56a9b222', 'border-color': 'lightgrey'};
    }
    return {};
  }

  resetAllValuesToDefault() {
    console.log("Reset all values to default");
    this.cardBackHeight = 0;
    this.previewedCard = '';
    this.originalCard = null;
    console.log("Has made stage? ", this.hasMadeStage);
    if (this.hasMadeStage) {
      this.stage.destroy();
    }
    this.hasMadeStage = false;
    this.stage = null;
    this.itemWithResize = null;
    this.runOverwrite = false;
    this.snapshotDefer = null;
    this.tempImageData = null;

    this.layer = null;
    this.imageSave = null;
    this.groupSave = null;
    this.fileUploading = null;
    this.resizeImageData = null;
    this.imageDefer = null;
    this.drawCanvasDefer = null;

    this.canvasHeight = 0;
    this.canvasWidth = 0;

    this.cbData = null;
    this.cbOriginalData = null;
    this.cbImgData = null;
    this.cbImgData1 = null;
    this.cbChangeCtx = null;
    this.colorVal = 30;

    this.hueSlider = 180;
    this.satSlider = 180;
    this.lumSlider = 180;
    this.colorTest = '#ffffff';

    this.updatePreviewTimer = null;
    this.runningUpdate = false;

    this.inFormatMode = false;
    this.inCropMode = false;
    this.subscription = null;
    this.cardBackColor = "";

    this.app.backgroundColor = "#ffffff";
    this.app.imageChanged = false;
    this.app.selectedImage = null;
    this.app.clickPixelForColor = false;
    this.app.images = [];
    this.app.hasImageAdded = false;
    this.runningEdit = false;
  }

  setUpdatePreview(addBack = true) {
    if (!this.app.hasImageAdded) {
      return;
    }
    if (this.updatePreviewTimer != null) {
      clearTimeout(this.updatePreviewTimer);
      this.updatePreviewTimer = null;
    }
    // this.processingChange = true;
    return;
    // this.updatePreviewTimer = setTimeout(() => {
    //   if (!this.runningUpdate) {
    //     this.runningUpdate = true;
    //     setTimeout(() => {
    //       this.createPreviewImage(addBack);
    //     });
    //   } else {
    //     this.setUpdatePreview();
    //   }
    // }, 1000);
  }

  clearUpdating() {
    if (this.updatePreviewTimer != null) {
      clearTimeout(this.updatePreviewTimer);
      this.updatePreviewTimer = null;
    }
  }

  ngOnInit() {
    console.log("Designer mobile ngOnInit");

    setTimeout(() => {
      $('#fileUpload').on('change', this.handleFileUpload);
      $('#fileUpload').on('focus', (evt) => {
        console.log("File upload focus");
      });
    }, 300);


    setTimeout(() => {
      // console.log("In canvas click timeout");
      let element = document.getElementById("container");
      if (element) {
        element.ontouchstart = (e) => {
          this.handleImageTouchEvent(e, element);
        };
      }
    }, 500);


    this.getFontList();

    console.log("NG On Init Draw Canvas");
    this.runDrawCanvasTimeout();

    this.zone.run(() => {
    });

    this.cardBackList.forEach((c) => {
      c.origBack = c.src;
    });
    if (this.app.selectedCardBack) {
      // console.log("Selectec card back: ", this.app.selectedCardBack);
      // this.cardBackClicked(this.app.selectedCardBack);
    }
    //This is here to fix the loading of the cards issue

  }

  handleFileUpload = (evt) => {
    // console.log("File upload change: ", evt);
    if (!this.app.hasImageAdded) {
      this.app.hasImageAdded = true;
      this.setupNewImage(this.app.images.length, "image", '/assets/Blank Image.jpg', false, false,
        200, 137, 50, 200, true);
      if (this.app.selectedImage !== null) {
        this.app.selectedImage.draggable = false;
      }
      this.app.selectedImage = this.app.images[this.app.images.length - 1];
      this.app.images.splice(this.app.images.length - 1, 1);
      this.app.images.splice(0, 0, this.app.selectedImage);
      //Moved the item to the front
    }
    this.app.selectedImage = this.app.images.find((t) => {
      return t.type === "image";
    });
    this.app.broadcast({event: 'hadImageAdded'});

    this.app.imageChanged = true;
    let reader = new FileReader();
    this.fileUploading = evt.target.files[0];
    // console.log("File uploading: ", this.fileUploading);
    reader.readAsDataURL(evt.target.files[0]);

    reader.onload = this.loaded;
  };

  runDrawCanvasTimeout = () => {
    setTimeout(() => {
      if (this.canvasHeight === 0) {
        this.runDrawCanvasTimeout();
      } else {
        this.drawPreviewCanvas();
      }
    }, 300);
  };

  handleImageTouchEvent = (e, element) => {
    if (this.app.clickPixelForColor) {
      var el = element.children[0].children[0];
      // console.log("Higher child: ", higherChild, higherChild.height, higherChild.width);
      console.log("Element click event: ", e);
      // console.log("Canvas element: ", el, eSl.offsetHeight, el.offsetWidth);
      var elHeight = el.offsetHeight, elWidth = el.offsetWidth;
      let cLeft = $('#container').offset().left;
      let cTop = $('#container').offset().top;
      console.log("Container Left: ", cLeft, " Top: ", cTop);
      if (!e.touches || e.touches.length === 0) {
        alert("An unknown error occurred detecting your selection, please try again");
        return;
      }
      let canvas: any = element.children[0].children[0];
      console.log("Offsets: ", element.offsetWidth, element.offsetHeight);
      console.log("Canvas: ", canvas.height, canvas.width);
      var touch = e.touches[0];
      console.log("Touch x: ", touch.pageX, touch.pageY);
      let x = (((touch.pageX - cLeft) / (el.offsetWidth)) * (canvas.width))
        , y = (((touch.pageY - cTop) / (el.offsetHeight)) * (canvas.height));
      // console.log("Click position: ", e.clientX, e.clientY);
      console.log("Element Coordinate of click: ", x, y);
      this.app.clickPixelForColor = false;

      let pixelData = canvas.getContext('2d').getImageData(x, y, 1, 1).data;
      console.log("Pixel data: ", pixelData);
      if (pixelData.length === 4) {
        if (pixelData[0] === 0 && pixelData[1] === 0 && pixelData[2] === 0) {
          return;
        }
        let hex = this.rgbToHex({r: pixelData[0], g: pixelData[1], b: pixelData[2]});
        // console.log("Hex: ", hex);
        this.cardBackColor = hex;
        this.cardBackColorSelChange();
      }
    }
  };

  ngOnDestroy() {
    this.resetAllValuesToDefault();
    $('#fileUpload').off('change', this.handleFileUpload);
  }

  cutOutSquare() {
    console.log("Cut out square");
    this.setupNewImage(this.app.images.length, "image", this.app.selectedCardBack.src, false, false,
      this.canvasWidth, this.canvasHeight, 0, 0, false);
    this.drawPreviewCanvas();
    // console.log("After first draw preview canvas");
    setTimeout(() => {
      // console.log("Inside of timeout");
      let element = document.getElementById("container");
      let canvas: any = element.children[0].children[0];
      let ctx = canvas.getContext('2d');
      ctx.fillStyle = "#f90";
      ctx.fillRect(0, 0, 200, 200);
      this.clipCanvas(ctx, 0, 0, 200, 200);
      let image = new Image();
      image.crossOrigin = "Anonymous";
      // console.log("After setup image object");
      image.onload = () => {
        // console.log("Image loaded");
        this.app.images.splice(this.app.images.length - 1, 1);
        if (this.app.selectedImage !== null && this.app.selectedImage.type === "image") {
          this.app.selectedImage.resizable = true;
        }
        // console.log("Before second draw preview");
        this.drawPreviewCanvas();
        // console.log("After secondd draw preview");
        let canvasSnapshot = image.src;
        canvasSnapshot = canvasSnapshot.replace('data:image/png;base64,', '');
        canvasSnapshot = canvasSnapshot.replace('data:image/jpg;base64,', '');
        let styleObject: CardStyle = this.makeStyleObject(canvasSnapshot);
        // console.log("Before defer");
        if (this.snapshotDefer !== null) {
          let id = this.runOverwrite ? this.app.selectedSavedCard.id : 0;
          this.snapshotDefer(id, styleObject, this.tempImageData);
          this.tempImageData = null;
          this.snapshotDefer = null;
        }
      };
      image.src = canvas.toDataURL("image/png");
    }, 500);
  }

  getSnapshot(addBack = true, images = null, addAnchors = true) {
    // console.log("Snapshot with preview generator");
    // console.log("Snapshot add back? ", addBack);
    let stage = new Konva.Stage({
      x: 0,
      y: 0,
      container: 'previewGenerator',
      width: this.canvasWidth,
      height: this.canvasHeight

    });
    let layer = new Konva.Layer();
    if (addBack) {
      let wh = this.getCanvasWidthAndHeight();
      let rect = new Konva.Rect({
        x: 0,
        y: 0,
        width: wh.w,
        height: wh.h,
        fill: this.app.backgroundColor,
        stroke: this.app.backgroundColor,
        strokeWidth: 0
      });
      layer.add(rect);
    }
    stage.add(layer);
    this.runPreviewMaker(stage, layer, images, addAnchors);
  }

  drawPreviewCanvas(generatingCard = false) {
    console.log("Drawing preview canvas");
    // console.log("Generating card? ", generatingCard);
    // if (this.stage !== null) {
    //   console.log("Stage destroy");
    //   this.stage.destroy();
    // }
    if (!this.hasMadeStage) {
      console.log("Adding stage", this.canvasWidth, this.canvasHeight);
      this.stage = new Konva.Stage({
        container: 'container',
        width: this.canvasWidth,
        height: this.canvasHeight
      });
      this.hasMadeStage = true;

      this.layer = new Konva.Layer();
      this.stage.add(this.layer);
    } else {
      console.log("Already added stage", this.canvasWidth, this.canvasHeight);
      this.stage.clearCache();
      this.stage.add(this.layer);
    }

    // if (this.layer !== null) {
    //   console.log("Layer destroy");
    //   this.layer.destroy();
    // }

    if (generatingCard) {
      var wh = this.getCanvasWidthAndHeight();
      // console.log("App background color: ", this.app.backgroundColor);
      var rect = new Konva.Rect({
        x: 0,
        y: 0,
        width: wh.w,
        height: wh.h,
        fill: this.app.backgroundColor,
        stroke: this.app.backgroundColor,
        strokeWidth: 0
      });

      // add the shape to the layer
      this.layer.add(rect);
    }
    this.runPreviewMaker(this.stage, this.layer);
  }

  runPreviewMaker(stage: any, layer: any, images: any = null, addAnchors = true) {
    let temp = [];
    if (images !== null) {
      let typeImage = images.filter((i) => {
        return i.type === "image" && i.src !== '/assets/Blank Image.jpg';
      });
      let typeText = images.filter((t) => {
        return t.type === "text";
      });
      typeImage.forEach((i) => {
        temp.push(i);
      });
      typeText.forEach((i) => {
        temp.push(i);
      });
    } else {
      this.app.images.forEach((i) => {
        if (i.type === "image" && i.src !== '/assets/Blank Image.jpg') {
          temp.push(i);
        }
      });
      this.app.images.forEach((i) => {
        if (i.type === "text") {
          temp.push(i);
        }
      });
    }

    let hasResize = false;
    let width = 0;
    let height = 0;
    this.itemWithResize = null;
    console.log("Temp files: ", temp, temp.length);
    temp.forEach((i) => {
      if (i.hasFormatAnchorsAdded || i.hasCropAnchorsAdded) {
        i.groupSave.removeChildren();
        i.hasFormatAnchorsAdded = false;
        i.hasCropAnchorsAdded = false;
      }
      if (i.type === "image") {
        this.createNewImage(i, i.src, i.draggable, i.resizable, i.width, i.height, i.x, i.y, layer);
      } else if (i.type === "text") {
        this.createTextImage(i, layer);
      }
      hasResize = i.resizable ? true : hasResize;
      if (hasResize && i.resizable && addAnchors) {
        width = i.width;
        height = i.height;
        this.itemWithResize = i;
      } else if (i.hasFormatAnchorsAdded) {
        i.groupSave.removeChildren();
        i.groupSave.add(i.imageSave);
        i.hasFormatAnchorsAdded = false;
      }
    });
    if (!this.itemWithResize) { //Rare occurrence
      for (let i = 0; i < temp.length; i++) {
        let item = temp[i];
        if (item.type === "image") {
          width = item.width;
          height = item.height;
          this.itemWithResize = item;
        }
      }
    }
    if (hasResize && addAnchors && this.inFormatMode) {
      if (this.itemWithResize.type === "text" && (this.itemWithResize.imageSave === null || this.itemWithResize.imageSave === undefined)) {
        // console.log("Waiting...");
        // This ability was taken away since I wasn't able to get it to work, may revisit later
        //Going to have to wait...
      } else {
        this.finishAddAnchors(this.itemWithResize, width, height);
      }
    } else if (addAnchors && this.inCropMode) {
      if (this.itemWithResize.type === "text" && (this.itemWithResize.imageSave === null || this.itemWithResize.imageSave === undefined)) {
        // console.log("Can't do the crop text");
      } else {
        this.itemWithResize.resizable = false;
        this.finishAddCropAnchors(this.itemWithResize, width, height);
      }
    } else {
      if (this.drawCanvasDefer) {
        this.drawCanvasDefer();
        this.drawCanvasDefer = null;
      }
    }
  }

  finishAddAnchors(itemWithResize, width, height) {
    // console.log("Adding anchors");
    this.addAnchor(this.getFormatAnchor(itemWithResize, 0), 0, 0, 'topLeft');
    this.addAnchor(this.getFormatAnchor(itemWithResize, 1), width, 0, 'topRight');
    this.addAnchor(this.getFormatAnchor(itemWithResize, 2), 0, height, 'bottomLeft');
    this.addAnchor(this.getFormatAnchor(itemWithResize, 3), width, height, 'bottomRight');
    if (this.drawCanvasDefer) {
      this.drawCanvasDefer();
      this.drawCanvasDefer = null;
    }
  }

  finishAddCropAnchors(itemWithResize, width, height) {
    // console.log("Adding anchors");
    var half = this.cropCornersSize / 2;
    this.addCropAnchor(this.getCropAnchor(itemWithResize, 0), itemWithResize.imageSave, itemWithResize.groupSave,
      -1 * half, -1 * half, 'topLeftCrop');
    this.addCropAnchor(this.getCropAnchor(itemWithResize, 1), itemWithResize.imageSave, itemWithResize.groupSave,
      width - half, -1 * half, 'topRightCrop');
    this.addCropAnchor(this.getCropAnchor(itemWithResize, 2), itemWithResize.imageSave, itemWithResize.groupSave,
      -1 * half, height - half, 'bottomLeftCrop');
    this.addCropAnchor(this.getCropAnchor(itemWithResize, 3), itemWithResize.imageSave, itemWithResize.groupSave,
      width - half, height - half, 'bottomRightCrop');
    this.drawCropLines(itemWithResize);
    if (this.drawCanvasDefer) {
      this.drawCanvasDefer();
      this.drawCanvasDefer = null;
    }
  }

  setupNewImage(id, type, src, draggable, resizable, width, height, x, y, uploaded, textSetup = null) {
    this.app.images.push(this.makeImageObject(id, type, src, draggable, resizable, width, height, x, y, uploaded, textSetup));
  }

  makeImageObject(id, type, src, draggable, resizable, width, height, x, y, uploaded, textSetup = null) {
    return {
      id: id,
      type: type,
      src: src,
      draggable: draggable,
      resizable: resizable,
      width: width,
      height: height,
      x: x,
      y: y,
      uploaded: uploaded,
      textSetup: textSetup
    };
  }

  createNewImage(info, src, draggable, resizable, width, height, x, y, layer) {
    let data = new Image();
    if (info.hasKonvaImage) {
      info.imageSave.setAttrs({
        x: 0,
        y: 0,
        width: width,
        height: height
      });
    } else {
      let image = new Konva.Image({
        x: 0,
        y: 0,
        width: width,
        height: height
      });
      info.imageSave = image;
      info.hasKonvaImage = true;
    }

    if (info.hasKonvaGroup) {
      info.groupSave.setAttrs({
        x: x,
        y: y,
        draggable: draggable
      });
    } else {
      let group = new Konva.Group({
        x: x,
        y: y,
        draggable: draggable
      });
      info.groupSave = group;
      info.hasKonvaGroup = true;
    }


    if (resizable) {
      this.groupSave = info.groupSave;
    }
    layer.add(info.groupSave);
    info.groupSave.add(info.imageSave);

    info.groupSave.on("dragmove", () => {
      // console.log("Group Drag move", image, group);
      if (this.dragCheckFails(info.imageSave, info.groupSave)) {
        console.log("Drag fails");
        return;
      }
      if (this.inFormatMode || this.inCropMode) {
        let x = 0, y = 0;
        if (info.imageSave.attrs.x !== null && info.imageSave.attrs.x !== undefined) {
          x = info.imageSave.attrs.x;
        }
        if (info.imageSave.attrs.y !== null && info.imageSave.attrs.y !== undefined) {
          y = info.imageSave.attrs.y;
        }
        let ima = this.app.images.find((im) => {
          if (im.id === info.id) {
            return im;
          }
        });
        if (ima !== null) {
          ima.x = info.groupSave.attrs.x + x;
          ima.y = info.groupSave.attrs.y + y;
        }
      }

      this.clearUpdating();
    });

    info.groupSave.on("dragend", () => {
      // console.log("Image dragend: ", this.app.selectedImage);
      if (this.dragCheckFails(info.imageSave, info.groupSave)) {
        return;
      }
      if (this.inFormatMode || this.inCropMode) {
        let x = 0, y = 0;
        if (info.imageSave.attrs.x != null) {
          x = info.imageSave.attrs.x;
        }
        if (info.imageSave.attrs.y != null) {
          y = info.imageSave.attrs.y;
        }
        let ima = this.app.images.find((im) => {
          if (im.id === info.id) {
            return im;
          }
        });
        if (ima !== null) {
          ima.x = info.groupSave.attrs.x + x;
          ima.y = info.groupSave.attrs.y + y;
        }
        if (this.app.selectedImage.type === "text" && this.app.selectedImage.textResized === true) {
          // console.log("Is text image and was resized");
          this.app.selectedImage.textResized = false;
          this.refreshTextItemSize();
        }
        this.setUpdatePreview();
      }
    });

    info.groupSave.on("mousedown", () => {
      // console.log("Group mouse down");
    });

    info.groupSave.on("mouseup", () => {
      // console.log("Group mouse up");
    });

    info.groupSave.on("touchstart", (e) => {
      // console.log("Group mouse down");
      console.log("Touch start: ", e);
    });

    info.groupSave.on("touchmove", (e) => {
      // console.log("Group mouse down");
      console.log("Touch move: ", e);
    });

    info.groupSave.on("touchend", (e) => {
      // console.log("Group mouse down");
      console.log("Touch end: ", e);
    });

    data.onload = () => {
      info.imageSave.image(data);
      layer.draw();
    };
    data.src = src;
  }

  textImageLoaded(image, info, layer) {
    this.createNewImage(info, image.src, info.draggable, info.resizable, image.width, image.height, info.x, info.y, layer);
  }

  refreshTextItemSize() {
    let newWidth = this.app.selectedImage.width;
    let origFont = this.app.selectedImage.textSetup.fontSize;
    let newFont = origFont;
    console.log("Item font size: ");
    // console.log("New width that's needed: ", );
    let origWidth = this.getTextWidth(this.app.selectedImage);
    // console.log("Orig width: ", origWidth);
    if (origWidth < newWidth) {
      while (origWidth < newWidth) {
        origFont = origFont + 1;
        this.app.selectedImage.textSetup.fontSize = origFont;
        origWidth = this.getTextWidth(this.app.selectedImage);
      }
      origFont = origFont - 1;
    } else {
      while (origWidth > newWidth) {
        origFont = origFont - 1;
        this.app.selectedImage.textSetup.fontSize = origFont;
        origWidth = this.getTextWidth(this.app.selectedImage);
      }
      origFont = origFont + 1;
    }
    this.app.selectedImage.textSetup.fontSize = origFont;
    // console.log("New font size: ", origFont);
    if (!this.app.hasImageAdded) {
      this.drawPreviewCanvas();
    }
  }

  update(activeAnchor, crop) {
    // console.log("Update anchor");
    let group = activeAnchor.getParent();

    let topLeft = crop ? this.itemWithResize.TLCAnchor : this.itemWithResize.TLFAnchor;
    let topRight = crop ? this.itemWithResize.TRCAnchor : this.itemWithResize.TRFAnchor;
    let bottomRight = crop ? this.itemWithResize.BRCAnchor : this.itemWithResize.BRFAnchor;
    let bottomLeft = crop ? this.itemWithResize.BLCAnchor : this.itemWithResize.BLFAnchor;
    let image = this.itemWithResize.imageSave;

    let anchorX = activeAnchor.getX();
    let anchorY = activeAnchor.getY();

    let extra = crop ? 'Crop' : '';
    // update anchor positions
    switch (activeAnchor.getName()) {
      case 'topLeft' + extra:
        topRight.setY(anchorY);
        bottomLeft.setX(anchorX);
        break;
      case 'topRight' + extra:
        topLeft.setY(anchorY);
        bottomRight.setX(anchorX);
        break;
      case 'bottomRight' + extra:
        bottomLeft.setY(anchorY);
        topRight.setX(anchorX);
        break;
      case 'bottomLeft' + extra:
        bottomRight.setY(anchorY);
        topLeft.setX(anchorX);
        break;
    }


    if (!crop) {
      image.position(topLeft.position());

      let width = topRight.getX() - topLeft.getX();
      let height = bottomLeft.getY() - topLeft.getY();
      if (width && height) {
        image.width(width);
        image.height(height);
      }
    } else { //Specific stuff for when cropping
      // console.log("Cropping drag: Width = " + this.app.selectedImage.width + " Height = " + this.app.selectedImage.height);
      let top = group.get('.topLine')[0];
      let right = group.get('.rightLine')[0];
      let left = group.get('.leftLine')[0];
      let bottom = group.get('.bottomLine')[0];
      let half = (this.cropCornersSize / 2);
      switch (activeAnchor.getName()) {
        case 'topLeft' + extra:
          top.setY(anchorY + half);
          top.setX(anchorX + this.cropCornersSize);
          top.setWidth(topRight.getX() - anchorX - this.cropCornersSize);
          bottom.setY(bottomLeft.getY() + half);
          bottom.setX(bottomLeft.getX() + this.cropCornersSize);
          bottom.setWidth(topRight.getX() - anchorX - this.cropCornersSize);
          left.setX(anchorX + half);
          left.setY(anchorY + this.cropCornersSize);
          left.setHeight(bottomLeft.getY() - anchorY - this.cropCornersSize);
          right.setX(topRight.getX() + half);
          right.setY(topRight.getY() + this.cropCornersSize);
          right.setHeight(bottomLeft.getY() - anchorY - this.cropCornersSize);
          break;
        case 'topRight' + extra:
          top.setY(topLeft.getY() + half);
          top.setX(topLeft.getX() + this.cropCornersSize);
          top.setWidth(anchorX - topLeft.getX() - this.cropCornersSize);
          bottom.setWidth(anchorX - topLeft.getX() - this.cropCornersSize);
          right.setX(anchorX + half);
          right.setY(anchorY + this.cropCornersSize);
          right.setHeight(bottomRight.getY() - anchorY - this.cropCornersSize);
          left.setY(topLeft.getY() + this.cropCornersSize);
          left.setX(topLeft.getX() + half);
          left.setHeight(bottomRight.getY() - anchorY - this.cropCornersSize);
          break;
        case 'bottomRight' + extra:
          bottom.setY(bottomLeft.getY() + half);
          bottom.setX(bottomLeft.getX() + this.cropCornersSize);
          bottom.setWidth(anchorX - bottomLeft.getX() - this.cropCornersSize);
          top.setWidth(anchorX - bottomLeft.getX() - this.cropCornersSize);
          right.setX(topRight.getX() + half);
          right.setY(topRight.getY() + this.cropCornersSize);
          right.setHeight(anchorY - topRight.getY() - this.cropCornersSize);
          left.setHeight(anchorY - topRight.getY() - this.cropCornersSize);
          break;
        case 'bottomLeft' + extra:
          bottom.setY(anchorY + half);
          bottom.setX(anchorX + this.cropCornersSize);
          bottom.setWidth(bottomRight.getX() - anchorX - this.cropCornersSize);
          top.setX(topLeft.getX() + this.cropCornersSize);
          top.setY(topLeft.getY() + half);
          top.setWidth(bottomRight.getX() - anchorX - this.cropCornersSize);
          left.setX(topLeft.getX() + half);
          left.setY(topLeft.getY() + this.cropCornersSize);
          left.setHeight(anchorY - topLeft.getY() - this.cropCornersSize);
          right.setHeight(anchorY - topLeft.getY() - this.cropCornersSize);
          break;
      }
    }
  }

  addCropAnchor(anchor, image, group, x, y, name, line = false) {
    let stage = group.getStage();
    let layer = group.getLayer();

    anchor.setAttrs({
      x: x,
      y: y,
      stroke: '#ffffff',
      width: this.cropCornersSize,
      height: this.cropCornersSize,
      fill: "red",
      name: name,
      strokeWidth: 0,
      draggable: true,
      dragOnTop: false
    });

    group.add(anchor);
    this.itemWithResize.hasCropAnchorsAdded = true;
  }

  drawCropLines(item) {
    let topLeft = item.TLCAnchor;
    let topRight = item.TRCAnchor;
    let bottomRight = item.BRCAnchor;
    let bottomLeft = item.BLCAnchor;

    // console.log("Top Left = X: " + topLeft.getX() + " Y: " + topLeft.getY());

    let tlX = topLeft.getX() + (this.cropCornersSize / 2);
    let tlY = topLeft.getY() + (this.cropCornersSize / 2);
    let trX = topRight.getX() + (this.cropCornersSize / 2);
    let trY = topRight.getY() + (this.cropCornersSize / 2);

    let brX = bottomRight.getX() + (this.cropCornersSize / 2);
    let brY = bottomRight.getY() + (this.cropCornersSize / 2);
    let blX = bottomLeft.getX() + (this.cropCornersSize / 2);
    let blY = bottomLeft.getY() + (this.cropCornersSize / 2);

    this.addCropLine(item.groupSave, tlX + (this.cropCornersSize / 2), tlY, trX - tlX - this.cropCornersSize,
      true, "topLine", "red");
    this.addCropLine(item.groupSave, trX, trY + (this.cropCornersSize / 2), brY - trY - this.cropCornersSize,
      false, "rightLine", "red");
    this.addCropLine(item.groupSave, tlX, tlY + (this.cropCornersSize / 2), blY - tlY - this.cropCornersSize,
      false, "leftLine", "red");
    this.addCropLine(item.groupSave, blX + (this.cropCornersSize / 2), blY, brX - blX - this.cropCornersSize,
      true, "bottomLine", "red");
  }

  addCropLine(group, x, y, length, toSide, name, color) {
    let anchor = new Konva.Rect({
      x: x,
      y: y,
      stroke: color,
      width: toSide ? length : 2,
      height: toSide ? 2 : length,
      fill: color,
      name: name,
      strokeWidth: 1
    });

    group.add(anchor);
  }

  getFormatAnchor(itemWithResize, type: number) {
    switch (type) {
      case 0:
        if (!itemWithResize.addedTLFAnchor) {
          itemWithResize.TLFAnchor = this.makeNewAnchor('topLeft');
          itemWithResize.addedTLFAnchor = true;
        }
        return itemWithResize.TLFAnchor;
      case 1:
        if (!itemWithResize.addedTRFAnchor) {
          itemWithResize.TRFAnchor = this.makeNewAnchor('topRight');
          itemWithResize.addedTRFAnchor = true;
        }
        return itemWithResize.TRFAnchor;
      case 2:
        if (!itemWithResize.addedBLFAnchor) {
          itemWithResize.addedBLFAnchor = true;
          itemWithResize.BLFAnchor = this.makeNewAnchor('bottomLeft');
        }
        return itemWithResize.BLFAnchor;
      case 3:
        if (!itemWithResize.addedBRFAnchor) {
          itemWithResize.addedBRFAnchor = true;
          itemWithResize.BRFAnchor = this.makeNewAnchor('bottomRight');
        }
        return itemWithResize.BRFAnchor;
    }
  }

  getCropAnchor(itemWithResize, type: number) {
    switch (type) {
      case 0:
        if (!itemWithResize.addedTLCAnchor) {
          itemWithResize.TLCAnchor = this.makeCropAnchor('topLeftCrop');
          itemWithResize.addedTLCAnchor = true;
        }
        return itemWithResize.TLCAnchor;
      case 1:
        if (!itemWithResize.addedTRCAnchor) {
          itemWithResize.TRCAnchor = this.makeCropAnchor('topRightCrop');
          itemWithResize.addedTRCAnchor = true;
        }
        return itemWithResize.TRCAnchor;
      case 2:
        if (!itemWithResize.addedBLCAnchor) {
          itemWithResize.addedBLCAnchor = true;
          itemWithResize.BLCAnchor = this.makeCropAnchor('bottomLeftCrop');
        }
        return itemWithResize.BLCAnchor;
      case 3:
        if (!itemWithResize.addedBRCAnchor) {
          itemWithResize.addedBRCAnchor = true;
          itemWithResize.BRCAnchor = this.makeCropAnchor('bottomRightCrop');
        }
        return itemWithResize.BRCAnchor;
    }
  }

  makeNewAnchor(name) {
    let anchor = new Konva.Circle({
      x: 0,
      y: 0,
      stroke: '#000000',
      fill: '#ffffff',
      strokeWidth: 2,
      radius: this.cropCornersSize / 2,
      name: name,
      draggable: true,
      dragOnTop: false
    });

    anchor.on('dragmove', () => {
      console.log("Anchor drag move");
      // if (this.dragCheckFails(image, group)) {
      //   return;
      // }
      const pointerPos = this.stage.getPointerPosition();
      if (this.app.selectedImage.type === "text") {
        this.app.selectedImage.textResized = true;
      }
      this.app.selectedImage.width = this.itemWithResize.imageSave.attrs.width;
      this.app.selectedImage.height = this.itemWithResize.imageSave.attrs.height;
      this.app.selectedImage.x = this.itemWithResize.groupSave.attrs.x + pointerPos.x;
      this.app.selectedImage.y = this.itemWithResize.groupSave.attrs.y + pointerPos.y;
      this.dragMove(anchor, this.itemWithResize.layer);
      this.clearUpdating();
    });
    anchor.on('mousedown touchstart', () => {
      this.mouseDown(anchor, this.itemWithResize.groupSave);
    });
    anchor.on('dragend', () => {
      // if (this.dragCheckFails(image, group)) {
      //   return;
      // }
      console.log("Height: ", this.itemWithResize.imageSave.attrs.height, this.itemWithResize.imageSave.attrs.width);
      const pointerPos = this.stage.getPointerPosition();
      if (this.itemWithResize.imageSave.attrs.height < 0 || this.itemWithResize.imageSave.attrs.width < 0) {
        console.log("Image.width is negative, returning now");
        return;
      }
      // if (image.attrs.width < 0) {
      // console.log("Image width is less than 0, it should not have gotten here");
      // }
      this.app.selectedImage.width = this.itemWithResize.imageSave.attrs.width;
      this.app.selectedImage.height = this.itemWithResize.imageSave.attrs.height;
      let newX = this.itemWithResize.groupSave.attrs.x + pointerPos.x;
      let newY = this.itemWithResize.groupSave.attrs.y + pointerPos.y;
      this.app.selectedImage.x = newX;
      this.app.selectedImage.y = newY;
      // console.log("Selected image: ", this.app.selectedImage);
      this.itemWithResize.groupSave.setDraggable(true);
      this.layer.draw();
      this.setUpdatePreview();
    });
    // add hover styling
    anchor.on('mouseover', function () {
      let layer = this.getLayer();
      document.body.style.cursor = 'pointer';
      this.setStrokeWidth(4);
      layer.draw();
    });
    anchor.on('mouseout', function () {
      let layer = this.getLayer();
      document.body.style.cursor = 'default';
      this.setStrokeWidth(2);
      layer.draw();
    });
    return anchor;
  }

  makeCropAnchor(name) {
    let anchor = new Konva.Rect({
      x: 0,
      y: 0,
      stroke: '#ffffff',
      width: this.cropCornersSize,
      height: this.cropCornersSize,
      fill: "red",
      name: name,
      strokeWidth: 0,
      draggable: true,
      dragOnTop: false
    });

    anchor.on('dragmove', () => {
      // console.log("Crop Drag move");
      this.dragMove(anchor, this.layer, true);
      this.clearUpdating();
    });
    anchor.on('mousedown touchstart', () => {
      // console.log("Crop Mouse down");
      this.mouseDown(anchor, this.itemWithResize.groupSave);
    });
    anchor.on('dragend', () => {
      // console.log("Crop Drag end");
      this.itemWithResize.groupSave.setDraggable(true);
      this.layer.draw();
    });
    // add hover styling
    anchor.on('mouseover', function () {
      // console.log("Crop Mouse over");
      let layer = this.getLayer();
      document.body.style.cursor = 'pointer';
      this.setStrokeWidth(4);
      layer.draw();
    });
    anchor.on('mouseout', function () {
      // console.log("Crop Mouse out");
      let layer = this.getLayer();
      document.body.style.cursor = 'default';
      this.setStrokeWidth(2);
      layer.draw();
    });

    return anchor;
  }

  addAnchor(anchor, x, y, name) {
    // let stage = group.getStage();
    let layer = this.itemWithResize.groupSave.getLayer();

    anchor.setAttrs({
      x: x,
      y: y,
      stroke: '#000000',
      fill: '#ffffff',
      strokeWidth: 2,
      radius: this.cropCornersSize / 2,
      name: name,
      draggable: true,
      dragOnTop: false
    });
    anchor.draggable(true);

    this.itemWithResize.groupSave.add(anchor);
    this.itemWithResize.hasFormatAnchorsAdded = true;
  }

  dragCheckFails(image, group) { //Return fail
    // console.log("Width & height: ", image.attrs.width, image.attrs.height);
    if (image.attrs.width !== null && image.attrs.height !== null &&
      Number.isNaN(image.attrs.width) || Number.isNaN(image.attrs.height)) {
      // console.log("Not an integer A");
      return true;
    }
    // console.log("Group X & Y: ", group.attrs.x, group.attrs.y);
    if (group.attrs.x !== null && group.attrs.y !== null &&
      Number.isNaN(group.attrs.x) || Number.isNaN(group.attrs.y)) {
      // console.log("Not an integer B");
      return true;
    }
    // console.log("Image X & Y: ", image.attrs.x, image.attrs.y);
    if (image.attrs.x && image.attrs.y) {
      if (Number.isNaN(image.attrs.x) || Number.isNaN(image.attrs.y)) {
        // console.log("Not an integer C");
        return true;
      }
    }
    return false;
  }

  dragMove = (anchor, layer, crop = false, image = null) => {
    // console.log("Drag move");
    this.update(anchor, crop);
    // layer.draw();
  };

  mouseDown = (anchor, group) => {
    // console.log("Mouse down");
    group.setDraggable(false);
    anchor.moveToTop();
  };

  changeImage() {
    $('#fileUpload').click();
  }

  removeImage() {
    console.log("Remove image: ", this.app.selectedImage);
    if (this.app.selectedImage.type !== "text") {
      this.app.imageChanged = false;
      this.app.hasImageAdded = false;
    }
    this.app.selectedImage.imageSave.destroy();
    this.app.selectedImage.groupSave.destroy();
    this.app.images = this.app.images.filter((i) => {
      return i.id !== this.app.selectedImage.id;
    });
    this.app.selectedImage = null;
    let count = 0;
    this.app.images.forEach((i) => {
      i.id = count;
      count++;
    });
    let found = false;
    for (let i = 0; i < this.app.images.length; i++) {
      let image = this.app.images[i];
      if (image.type === "text") {
        found = true;
        this.app.selectedImage = image;
        setTimeout(() => {
          this.imageClicked(this.app.selectedImage);
        }, 300);
      }
    }
    this.drawPreviewCanvas();
    this.setUpdatePreview();
  }

  addImage() {
    console.log("Mobile add image");
    $('#fileUpload').click();
  }

  addTextImage() {
    console.log("Add text image");
    let textItemCount = this.countTextObjects();
    if (textItemCount >= 4) {
      this.app.errorText = "You have reached the maximum number of text boxes already. Please consider combining some to add more text.";
      $('#errorModal').modal('show');
      return;
    }
    if (textItemCount > 0) {
      let lastTextItem = null;
      for (let i = this.app.images.length - 1; i >= 0; i--) {
        if (this.app.images[i].type === "text") {
          lastTextItem = this.app.images[i];
          break;
        }
      }
      this.setupNewImage(this.app.images.length, "text", '', false, true,
        200, 200, 50, 50, false,
        {text: "(Type Here)", fontSize: lastTextItem.textSetup.fontSize, font: lastTextItem.textSetup.font, color: lastTextItem.textSetup.color});
    } else {
      this.setupNewImage(this.app.images.length, "text", '', false, true,
        200, 200, 50, 50, false, {text: "(Type Here)", fontSize: 30, font: "Arial", color: "#000000"});
    }

    this.app.selectedImage = this.app.images[this.app.images.length - 1];
    this.app.images.forEach((i) => {
      i.draggable = false;
      i.resizable = false;
    });
    this.app.selectedImage.draggable = true;
    if (this.app.selectedImage.type === "image") {
      this.app.selectedImage.resizable = true;
    }
    this.drawPreviewCanvas();
    this.setUpdatePreview();
  }

  countTextObjects() {
    return this.app.images.filter((i) => {
      return i.type === "text";
    }).length;
  }

  loaded = (evt) => {
    let originalFile = evt.target.result;
    // console.log("File has loaded: ", originalFile);
    this.getOrientation(this.fileUploading, (orientation) => {
      this.orientationResult(orientation, originalFile);
    });
  };

  orientationResult = (orientation, origFile) => {
    // console.log("Orientation: ", orientation);
    if (this.app.isIOS) {
      // this.runOrientationHandle(orientation, origFile);
      this.runResizeImage(origFile);
    } else {
      this.runResizeImage(origFile);
    }
  };

  runOrientationHandle(orientation, origFile) {
    this.resetOrientation(origFile, orientation, (test) => {
      this.runResizeImage(test);
    });
  }

  runResizeImage(imageData) {
    if (imageData) {
      imageData = imageData.replace(this.fileUploading.type, '');
      this.imageDefer = () => {
        this.runImageDefer();
        this.imageDefer = null;
      };
      this.resizeImage(imageData, this.canvasWidth, this.canvasHeight);
    }
  }

  runImageDefer() {
    console.log("Run image defer");
    this.app.selectedImage.src = this.resizeImageData;
    this.drawPreviewCanvas();
    this.setUpdatePreview();
  }

  resizeImage(imageSrc, maxWidth, maxHeight) {
    console.log("resize Image");

    let image = new Image();
    image.crossOrigin = "Anonymous";
    image.onload = () => {
      // console.log("Image object: ", image);
      // console.log("onLoad", image.width, image.height, maxWidth, maxHeight);

      let canvas = document.createElement("canvas");
      canvas.style.display = "none";
      document.body.appendChild(canvas);

      if (image.width > maxWidth || image.height > maxHeight) {
        if (image.width >= image.height) {
          //landscape
          canvas.width = maxWidth;
          canvas.height = maxWidth * (image.height / image.width);
        } else {
          canvas.height = maxHeight;
          canvas.width = maxHeight * (image.width / image.height);
        }
      } else {
        canvas.width = image.width;
        canvas.height = image.height;
      }

      let ratioH = 1;
      let ratioW = 1;
      if (image.width > canvas.width) {
        ratioW = canvas.width / image.width;
      }
      if (image.height > canvas.height) {
        ratioH = canvas.height / image.height;
      }
      let ratio = ratioH < ratioW ? ratioH : ratioW;

      let context = canvas.getContext("2d");
      // console.log("Ratio for rescale: ", ratioW, ratioH);
      // console.log("Canvas dimensions: ", canvas.width, canvas.height);
      let wh = this.getCanvasWidthAndHeight();
      console.log("Selected image: ", this.app.selectedImage);
      this.app.selectedImage.height = (image.height * (ratio * .75));
      this.app.selectedImage.width = (image.width * (ratio * .75));
      this.app.selectedImage.x = ((wh.w - this.app.selectedImage.width) / 2);
      this.app.selectedImage.y = ((wh.h - this.app.selectedImage.height) / 2);
      // console.log("Selected image: ", this.app.createClone(this.app.selectedImage));
      // console.log("Selected image curr: ", this.app.selectedImage);
      context.scale(ratio, ratio);
      context.drawImage(image, 0, 0);

      this.resizeImageData = canvas.toDataURL("image/png");

      document.body.removeChild(canvas);

      if (this.imageDefer != null) {
        this.imageDefer();
      }
    };
    image.src = imageSrc;
  }

  getPreviewImagePos() {
    let div = document.getElementById("previewImageDiv");
    let w = div.clientWidth;
    return {'position': 'absolute', 'left': ((w - 188) / 2) + 'px', 'top': '100px'};
  }

  createPreviewImage(addBack = true, sendFinishOverwrite: boolean = false, sendFinishSave: boolean = false) {
    console.log("In create preview image");
    this.processingChange = true;
    if (this.app.selectedImage !== null && this.app.selectedImage.type === "image") {
      this.app.selectedImage.resizable = false;
    }
    if (this.app.images.length === 0) {
      alert("You don't have any images or text added to create an image with.");
      return;
    }
    // console.log("Running add image");
    this.setupNewImage(this.app.images.length, "image", this.app.selectedCardBack.src, false, false,
      this.canvasWidth, this.canvasHeight, 0, 0, false);
    this.getSnapshot(addBack, null, false);
    // console.log("After first draw preview canvas");
    setTimeout(() => {
      // console.log("Inside of timeout");
      let element = document.getElementById("previewGenerator");
      let canvas: any = element.children[0].children[0];
      let ctx = canvas.getContext('2d');
      let height = canvas.height;
      let width = canvas.width;
      // console.log("Height: ", height);
      // console.log("Width: ", width);
      // ctx.fillStyle = "#f90";
      // ctx.fillRect(0, 0, 200, 200);
      // this.clipCanvas(ctx, 0, 0, 200, 200);
      var image = new Image();
      // console.log("After setup image object");
      image.onload = () => {
        // console.log("Image loaded");
        this.app.images.splice(this.app.images.length - 1, 1);
        if (this.app.selectedImage !== null && this.app.selectedImage.type === "image") {
          this.app.selectedImage.resizable = true;
        }
        // console.log("Before second draw preview");
        this.drawPreviewCanvas();
        // console.log("After secondd draw preview");
        // console.log("Images: ", this.app.createClone(this.app.images));


        //THIS WAS WHERE THE PREVIEW WAS

        this.previewedCard = './assets/1Hollow.png';
        this.runningUpdate = false;
        this.processingChange = false;

        if (sendFinishOverwrite) {
          setTimeout(() => {
            this.app.broadcast({event: 'finishOverwrite'});
          }, 500);
        } else if (sendFinishSave) {
          setTimeout(() => {
            this.app.broadcast({event: 'finishCreateNewCard'});
          }, 500);
        }
      };
      image.src = canvas.toDataURL("image/png");
      this.generatedPreviewImage = image;
      // console.log("After to data url");
    }, 500);
  }

  setCardPreview() {
    let canvas = document.getElementById("previewContainerMobile");
    console.log("Canvas: ", canvas);
    let height = canvas.offsetHeight;
    let width = canvas.offsetWidth;
    let prev: any = document.getElementById("cardPreviewImgMobile");
    if (prev !== null && prev !== undefined) {
      prev.height = height;
      prev.width = width;
      let prevCont = prev.getContext('2d');
      // console.log("Height: ", height);
      // console.log("Width: ", width);
      prevCont.drawImage(this.generatedPreviewImage, 0, 0);
    }
  }

  finishCreateNewCard() {
    var data = this.generatedPreviewImage.src.replace('data:image/png;base64,', '');
    let styleObject: CardStyle = this.makeStyleObject(data);
    console.log("Style object: ", styleObject);
    let id = 0;
    this.app.makeNewCardBack(null).subscribe((data: any) => {
      // console.log("Orig style object: ", styleObject);
      // console.log("Card back saved! ", data);
      this.showBackOptions = false;
      this.app.userCards.push(data);
      this.app.selectedSavedCard = data;
      this.app.broadcast({event: 'imageSaved'});
    }, (error) => {
      // console.log("Save card back error: ", error);
    });
  }

  createNewCard() {
    if (this.app.user === null) {
      this.app.defer = () => this.createNewCard();
      $('#loginModal').modal('show');
      return;
    }

    this.createPreviewImage(true, false, true);
    return;
  }

  makeImageOnCardACookie(id, data) {
    // console.log("Make image cookie: ", id, data);
    // this.app.setImageCookie(id, data);
  }

  finishOverwrite() {
    var data = this.generatedPreviewImage.src.replace('data:image/png;base64,', '');
    let styleObject: CardStyle = this.makeStyleObject(data);
    console.log("Style object: ", styleObject);
    let id = this.runOverwrite ? this.app.selectedSavedCard.id : 0;
    this.app.updateCardBack(id, null).subscribe((data: any) => {
      // console.log("Card back saved! ", data);
      for (let i = 0; i < this.app.userCards.length; i++) {
        let card = this.app.userCards[i];
        if (card.id === this.app.selectedSavedCard.id) {
          this.app.userCards[i] = data;
          break;
        }
      }
      this.app.selectedSavedCard = data;
      this.runOverwrite = false;
      this.app.broadcast({event: 'imageSaved'});
    }, (error) => {
      // console.log("Save card back error: ", error);
    });
    this.app.broadcast({event: 'imageSaved'});
  }

  overwriteCard() {
    this.runOverwrite = true;
    if (this.app.selectedSavedCard !== null) {
      this.createPreviewImage(true, true);
      return;
    }
  }
  // this.snapshotDefer = (id, styleObject, origImageData) => {
  //   // console.log("Got to this point: ", id, styleObject);
  //   this.app.updateCardBack(id, styleObject).subscribe((data: any) => {
  //     // console.log("Card back saved! ", data);
  //
  //     for (let i = 0; i < this.app.userCards.length; i++) {
  //       let card = this.app.userCards[i];
  //       if (card.id === id) {
  //         this.app.userCards[i] = data;
  //         break;
  //       }
  //     }
  //     this.app.selectedSavedCard = data;
  //     this.makeImageOnCardACookie(data.id, origImageData);
  //     this.app.broadcast({event: 'imageSaved'});
  //   }, (error) => {
  //     // console.log("Save card back error: ", error);
  //   });
  // };

  runAddImage() {
    console.log("In run add image");
    if (this.app.selectedImage !== null && this.app.selectedImage.type === "image") {
      this.app.selectedImage.resizable = false;
    }
    if (this.app.images.length === 0) {
      alert("You don't have any images or text added to create an image with.");
      return;
    }
    // console.log("Running add image");
    this.setupNewImage(this.app.images.length, "image", this.app.selectedCardBack.src, false, false,
      this.canvasWidth, this.canvasHeight, 0, 0, false);
    this.drawPreviewCanvas(true);
    // console.log("After first draw preview canvas");
    setTimeout(() => {
      // console.log("Inside of timeout");
      let element = document.getElementById("container");
      let canvas: any = element.children[0].children[0];
      let ctx = canvas.getContext('2d');
      // ctx.fillStyle = "#f90";
      // ctx.fillRect(0, 0, 200, 200);
      // this.clipCanvas(ctx, 0, 0, 200, 200);
      let image = new Image();
      image.crossOrigin = "Anonymous";
      // console.log("After setup image object");
      image.onload = () => {
        // console.log("Image loaded");
        this.app.images.splice(this.app.images.length - 1, 1);
        if (this.app.selectedImage !== null && this.app.selectedImage.type === "image") {
          this.app.selectedImage.resizable = true;
        }
        // console.log("Before second draw preview");
        this.drawPreviewCanvas();
        // console.log("After secondd draw preview");
        let canvasSnapshot = image.src;
        canvasSnapshot = canvasSnapshot.replace('data:image/png;base64,', '');
        canvasSnapshot = canvasSnapshot.replace('data:image/jpg;base64,', '');
        let styleObject: CardStyle = this.makeStyleObject(canvasSnapshot);
        // console.log("Before defer");
        if (this.snapshotDefer !== null) {
          let id = this.runOverwrite ? this.app.selectedSavedCard.id : 0;
          this.snapshotDefer(id, styleObject, this.tempImageData);
          this.tempImageData = null;
          this.snapshotDefer = null;
        }
      };
      image.src = canvas.toDataURL("image/png");
      // console.log("After to data url");
    }, 500);
  }

  clipCanvas(ctx, x, y, w, h) {

    ctx.globalCompositeOperation = 'destination-out';

    // ctx.filter = "blur(25px)";  // "feather"
    ctx.beginPath();
    ctx.rect(x, y, w, h);
    ctx.fill();

    // reset comp. mode and filter
    ctx.globalCompositeOperation = 'source-over';
    ctx.filter = "none";
  }

  makeStyleObject(snapshot: string): CardStyle {
    let style = new CardStyle();
    style.sponsor = this.app.user.id;
    style.style = snapshot;
    style.card_back = this.app.creating.cardBack.id;
    let textItems = [];
    let image = null;
    this.app.creating.cardText.forEach((i) => {
      if (i.type === "text") {
        textItems.push(i);
      } else if (i.type === "image") {
        image = i;
      }
    });
    this.tempImageData = image.src;
    let uploadedPic = image.src.replace('data:image/png;base64,', '');
    uploadedPic = uploadedPic.replace('data:image/jpg;base64,', '');
    style.uploaded_image = uploadedPic;
    style.image_pos_x = image.x;
    style.image_pos_y = image.y;
    style.height = this.canvasHeight;
    style.width = this.canvasWidth;
    style.hue = this.hueSlider;
    style.luminosity = this.lumSlider;
    style.saturation = this.satSlider;
    style.image_size_width = image.width;
    style.image_size_height = image.height;
    style.background_color = this.app.backgroundColor;
    textItems.forEach((t) => {
      style.text_items.push(this.makeStyleText(t));
    });
    return style;
  }

  makeStyleText(item): StyleText {
    let style = new StyleText();
    style.text = item.textSetup.text;
    style.font = item.textSetup.font;
    style.font_size = item.textSetup.fontSize;
    style.font_color = item.textSetup.color;
    style.font_pos_x = item.x;
    style.font_pos_y = item.y;
    return style;
  }

  getGradientTest(type) {
    let gradient = {
      background: 'linear-gradient(to right'
    };
    if (this.originalCard !== null) {
      switch (type) {
        case 0:
          this.originalCard.hwheel.forEach((w) => {
            gradient.background = gradient.background + ', ' + w + '';
          });
          break;
        case 1:
          this.originalCard.swheel.forEach((w) => {
            gradient.background = gradient.background + ', ' + w + '';
          });
          break;
        case 2:
          this.originalCard.lwheel.forEach((w) => {
            gradient.background = gradient.background + ', ' + w + '';
          });
          break;
        default:
          break;
      }

    } else {
      this.originalCard = this.app.selectedCardBack;
    }
    gradient.background = gradient.background + ')';
    return gradient;
  }

  cardClickedHere() {
    console.log("Card physically clicked");
  }

  cardBackClicked(cardBack, hideBack: boolean = true, runUpdatePreview: boolean = true) {
    console.log("Card back click: ", cardBack, hideBack, runUpdatePreview);
    cardBack.src = cardBack.origBack;
    cardBack.wheel = [];
    this.setupColorWheels(cardBack);
    this.originalCard = cardBack;
    this.cbOriginalData = null;
    this.app.selectedCardBack = cardBack;
    if (hideBack) {
      this.showBackOptions = false;
    }
    this.colorTest = this.app.createClone(this.app.selectedCardBack.main);
    if (runUpdatePreview) {
      console.log("Set update preview");
      this.setUpdatePreview();
    }
  }

  setupColorWheels(cardBack) {
    // console.log("Update color wheel");
    if (cardBack.hwheel.length === 0 || cardBack.updateWheels) {
      // console.log("In update");
      cardBack.hwheel = [];
      cardBack.swheel = [];
      cardBack.lwheel = [];
      this.cardBackColor = cardBack.main;
      let rgb = this.hexToRgb(cardBack.main);
      let hsl = this.rgbToHsl(rgb.r, rgb.g, rgb.b);

      let hue = hsl.h * 240;
      let sat = hsl.s * 240;
      let lum = hsl.l * 240;
      cardBack.hue = hue;
      cardBack.saturation = sat;
      cardBack.luminosity = lum;

      if (cardBack.updateWheels) {
        hsl.h = this.hueSlider / 240;
      }

      for (let i = 0; i <= 360; i = i + 10) {
        let hRgb = this.hslToRgb(i / 360, 1, .5); //Hardcoded the s,l values to visible colors on hue slider
        let hhex = this.rgbToHex(hRgb);
        cardBack.hwheel.push(hhex);

        let sRgb = this.hslToRgb(hsl.h, i / 360, .5); //Hardcoded the s,l values to visible colors on hue slider
        let shex = this.rgbToHex(sRgb);
        cardBack.swheel.push(shex);

        let lRgb = this.hslToRgb(hsl.h, 1, i / 360); //Hardcoded the s,l values to visible colors on hue slider
        let lhex = this.rgbToHex(lRgb);
        cardBack.lwheel.push(lhex);
      }
      // if (!cardBack.updateWheels) {
      this.hueSlider = Math.floor(hue);
      this.satSlider = Math.floor(sat);
      this.lumSlider = Math.floor(lum);
      // }
      cardBack.updateWheels = false;
    }
  }

  getColorOfImage() {
    // let canvas: any = document.getElementById("imageColorTest");
    // let image = new Image();
    // image.onload = (data) => {
    //   canvas.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
    //   let picData = canvas.getContext('2d').getImageData(this.app.selectedCardBack.x, this.app.selectedCardBack.y, 1, 1).data;
    //   // console.log("Pic data: ", picData);
    // };
    // image.src = this.app.selectedCardBack.src;
    // this.colorTest = "#8388ff";
  }

  createTextImage(imageInfo, layer: any) {
    let textWidth = this.getTextWidth(imageInfo);

    let canvas2 = document.createElement("canvas");
    canvas2.style.display = "none";
    document.body.appendChild(canvas2);
    let ctx2 = canvas2.getContext("2d");
    var adjust = Math.ceil(textWidth * 0.1);
    imageInfo.width = Math.ceil(textWidth + (adjust * 2));
    imageInfo.height = Math.ceil(imageInfo.textSetup.fontSize * 1.75);
    canvas2.width = Math.ceil(textWidth + (adjust * 2));
    canvas2.height = Math.ceil(imageInfo.textSetup.fontSize * 1.75);
    ctx2.font = "bold " + imageInfo.textSetup.fontSize + "px " + imageInfo.textSetup.font;
    ctx2.textAlign = "left";
    ctx2.fillStyle = imageInfo.textSetup.color;
    ctx2.strokeStyle = imageInfo.textSetup.color;
    ctx2.lineWidth = 2;
    ctx2.fillText(imageInfo.textSetup.text, adjust, imageInfo.textSetup.fontSize + 5);
    ctx2.strokeText(imageInfo.textSetup.text, adjust, imageInfo.textSetup.fontSize + 5);

    let image = new Image();
    image.crossOrigin = "Anonymous";
    image.onload = () => {

    };
    image.src = canvas2.toDataURL("image/png");
    this.textImageLoaded(image, imageInfo, layer);
    document.body.removeChild(canvas2);
  }

  getTextWidth(imageInfo) {
    let canvas = document.createElement("canvas");
    canvas.style.display = "none";
    document.body.appendChild(canvas);

    canvas.width = 600;
    canvas.height = 400;
    let ctx = canvas.getContext("2d");
    ctx.font = "bold " + imageInfo.textSetup.fontSize + "px " + imageInfo.textSetup.font;
    ctx.textAlign = "left";
    ctx.fillStyle = imageInfo.textSetup.color;
    ctx.lineWidth = 2;
    let textWidth = ctx.measureText(imageInfo.textSetup.text).width;
    document.body.removeChild(canvas);
    return textWidth;
  }

  updateTextBox() {
    console.log("Update text box");
    this.drawPreviewCanvas();
    this.setUpdatePreview();
  }

  updateFont(font) {
    this.app.selectedImage.textSetup.font = font.name;
    this.updateTextBox();
  }

  getFontList() {
    let fonts = [
      "Arial",
      "Comic Sans MS",
      "Courier New",
      "Georgia",
      "Impact",
      "Lucida Console",
      "Lucida Sans Unicode",
      "Times New Roman",
      "Tahoma",
      "Trebuchet MS",
      "Verdana",
    ];
    this.app.fontList = fonts;
  }

  getCanvasCenter(background = null) {
    let container = document.getElementById("canvasContainer");
    let height = container.clientHeight;
    let width = container.clientWidth;
    let widthSize = width - 30;
    let heightSize = Math.ceil(widthSize * 1.4463);
    if (heightSize > (height)) {
      heightSize = (height);
      widthSize = Math.ceil((height) / 1.4463);
    }
    let top = Math.ceil((height - heightSize) / 2);

    this.canvasHeight = heightSize;
    this.canvasWidth = widthSize;
    let left = (width - widthSize) / 2;
    if (background === null) {
      return {
        'left': left + 'px', 'top': top + 'px',
        'width': widthSize + 'px', 'height': heightSize + 'px',
        'cursor': !this.app.clickPixelForColor ? 'auto' : 'crosshair'
      };
    } else {
      return {
        'left': left + 'px', 'top': top + 'px',
        'background-color': background, 'width': widthSize + 'px',
        'height': heightSize + 'px', 'cursor': !this.app.clickPixelForColor ? 'auto' : 'crosshair'
      };
    }
  }

  getCardBackCenter(background = null) {
    let container = document.getElementById("canvasContainer");
    let height = container.clientHeight;
    let width = container.clientWidth;
    let widthSize = width - 30;
    let heightSize = Math.ceil(widthSize * 1.4463);
    if (heightSize > (height)) {
      heightSize = (height);
      widthSize = Math.ceil((height) / 1.4463);
    }
    let top = Math.ceil((height - heightSize) / 2);

    this.canvasHeight = heightSize;
    this.canvasWidth = widthSize;
    let left = (width - widthSize) / 2;
    if (background === null) {
      return {
        'left': left + 'px', 'top': top + 'px',
        'width': widthSize + 'px', 'height': heightSize + 'px'
      };
    } else {
      return {
        'left': left + 'px', 'top': top + 'px',
        'background-color': background, 'width': widthSize + 'px', 'height': heightSize + 'px'
      };
    }
  }

  getCanvasWidthAndHeight() {
    let container = document.getElementById("container");
    let height = container.clientHeight;
    let width = container.clientWidth;
    let widthSize = width;
    let heightSize = Math.ceil(widthSize * 1.6);
    // if (heightSize > (height - 20)) {
    //   heightSize = (height - 20);
    //   widthSize = Math.ceil((height - 20) / 1.6);
    // }
    return {w: widthSize, h: heightSize};
  }

  imageClicked(image) {
    console.log("Image clicked in hierarchy: ");

    this.app.selectedImage = image;
    this.app.images.forEach((i) => {
      i.draggable = false;
      i.resizable = false;
    });
    if (image.type === "text") {
      for (let i = 0; i < this.app.images.length; i++) {
        if (this.app.images[i].id === image.id) {
          this.app.images.splice(i, 1);
          break;
        }
      }
      this.app.images.push(image);
      //Moving the test item to the end so it is on top and draggable
    }

    image.draggable = true;
    image.resizable = true;
    this.drawPreviewCanvas();
  }

  getCardBackDisplayStyle(cardBack) {
    // let el = document.getElementById("cardBack" + cardBack.id);
    // if (!el) {
    //   return {};
    // }
    // let height = el.clientHeight;
    // let width = el.clientWidth;
    //
    // cardBack.width = width - 30;
    // cardBack.height = Math.ceil((width - 30) * 1.4463);
    // cardBack.elHeight = height;
    // this.cardBackHeight = height;
    // let margin = 10;
    // if (cardBack.elHeight) {
    //   margin = Math.ceil((cardBack.elHeight - cardBack.height) / 2);
    // }
    return cardBack.id === this.app.selectedCardBack.id ?
      {'border': '1px solid green', 'box-shadow': '1px 1px 7px 2px #ffd11a'} :
      {'border': '1px solid black'};
  }

  getBlankCardStyle(cardBack) {
    if (!cardBack.elHeight || this.cardBackHeight < 100) {
      return {'display': 'none'};
    }
    if (!this.app.hasRunBlankRefresh) {
      this.app.hasRunBlankRefresh = true;
      setTimeout(() => {
        let cb = $('#cardBack0');
        if (cb !== null) {
          // cb.click();
          this.cardBackClicked(this.cardBackList[0], false);
        }
      });
    }

    return {'line-height': this.cardBackHeight + 'px', 'height': this.cardBackHeight + 'px'};
  }

  getOrientation(file, callback) {
    let reader = new FileReader();
    reader.onload = (e: any) => {
      // console.log("getOrientation");
      let view = new DataView(e.target.result);
      if (view.getUint16(0, false) !== 0xFFD8) {
        console.log("Returning -2");
        return callback(-2);
      }
      let length = view.byteLength, offset = 2;
      console.log("Length: ", length);
      while (offset < length) {
        let marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) {
            console.log("At this -1 callback");
            return callback(-1);
          }
          let little = view.getUint16(offset += 6, false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          let tags = view.getUint16(offset, little);
          offset += 2;
          for (let i = 0; i < tags; i++) {
            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
              return callback(view.getUint16(offset + (i * 12) + 8, little));
            }
          }
        } else if ((marker & 0xFF00) !== 0xFF00) {
          break;
        } else {
          offset += view.getUint16(offset, false);
        }
      }
      console.log("At the ending callback");
      return callback(-1);

    };
    reader.readAsArrayBuffer(file);
  }

  resetOrientation(srcBase64, srcOrientation, callback) {
    let img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      // console.log("in resetorientation onload");
      let width = img.width,
        height = img.height,
        canvas = document.createElement('canvas'),
        ctx = canvas.getContext("2d");

      // set proper canvas dimensions before transform & export
      if (4 < srcOrientation && srcOrientation < 9) {
        console.log("orientation a");
        canvas.width = height;
        canvas.height = width;
      } else {
        // console.log("orientation b");
        canvas.width = width;
        canvas.height = height;
      }

      // srcOrientation = 0;

      // transform context before drawing image
      switch (srcOrientation) {
        case 2:
          ctx.transform(-1, 0, 0, 1, width, 0);
          break;
        case 3:
          ctx.transform(-1, 0, 0, -1, width, height);
          break;
        case 4:
          ctx.transform(1, 0, 0, -1, 0, height);
          break;
        case 5:
          ctx.transform(0, 1, 1, 0, 0, 0);
          break;
        case 6:
          ctx.transform(0, 1, -1, 0, height, 0);
          break;
        case 7:
          ctx.transform(0, -1, -1, 0, height, width);
          break;
        case 8:
          ctx.transform(0, -1, 1, 0, 0, width);
          break;
        default:
          break;
      }

      // draw image
      ctx.drawImage(img, 0, 0);

      // export base64
      callback(canvas.toDataURL());
    };

    img.src = srcBase64;
  }

  changeHsl(type, hue, sat, lum) {
    console.log("Change hsl: ", hue, sat, lum);
    let tempList = [];
    tempList.push(this.makeImageObject(this.app.images.length, "image", this.originalCard.src, false, false,
      this.canvasWidth, this.canvasHeight, 0, 0, false));
    this.getSnapshot(false, tempList, false);
    // console.log("After first draw preview canvas");
    setTimeout(() => {
      // console.log("Inside of timeout");
      let element = document.getElementById("previewGenerator");
      let canvas: any = element.children[0].children[0];
      let ctx = canvas.getContext('2d');
      this.cbChangeCtx = ctx;
      let image = new Image();
      image.onload = () => {
        // console.log("Image loaded");
        // image = this.colorImage(image, '#00ff00');
        let cw = canvas.width = image.width;
        let ch = canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        this.cbImgData = ctx.getImageData(0, 0, cw, ch);
        this.cbData = this.cbImgData.data;
        this.cbImgData1 = ctx.getImageData(0, 0, cw, ch);
        if (type === 0 || this.cbOriginalData === null) {
          // console.log("Update original data");
          this.cbOriginalData = this.cbImgData1.data;
        }

        this.colorVal = this.colorVal + 10;
        this.app.selectedCardBack.src = this.hslShift(type, canvas, hue, sat, lum);

        // Updates using the update timer
        // setTimeout(() => {
        //   this.createPreviewImage(true);
        // }, 100);
      };
      image.src = canvas.toDataURL("image/png");
    }, 500);
  }

  hexToRgb(color) {
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    color = color.replace(shorthandRegex, (m, r, g, b) => {
      return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : {
      r: 0,
      g: 0,
      b: 0
    };
  }

  componentToHex(c) {
    let hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  rgbToHex(rgb) {
    return "#" + this.componentToHex(rgb.r) + this.componentToHex(rgb.g) + this.componentToHex(rgb.b);
  }

  colorImage(imgElement, hexaColor) {
    // create hidden canvas (using image dimensions)
    let canvas = document.createElement("canvas");
    canvas.width = imgElement.width;
    canvas.height = imgElement.height;

    let ctx = canvas.getContext("2d");
    ctx.drawImage(imgElement, 0, 0);

    let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    let data = imageData.data;

    // convert image to grayscale
    let rgbColor = this.hexToRgb(hexaColor);

    for (let p = 0, len = data.length; p < len; p += 4) {
      if (data[p + 3] == 0) {
        continue;
      }
      data[p + 0] = rgbColor.r;
      data[p + 1] = rgbColor.g;
      data[p + 2] = rgbColor.b;
      data[p + 3] = 255;
    }
    ctx.putImageData(imageData, 0, 0);

    // replace image source with canvas data
    imgElement.src = canvas.toDataURL();
    return imgElement;
  }

  cardBackColorSelChange() {
    // console.log("Card back color change: ", this.cardBackColor);
    let rgb = this.hexToRgb(this.cardBackColor);
    // console.log("RGB: ", rgb);
    let hsl = this.rgbToHsl(rgb.r, rgb.g, rgb.b);
    // console.log("HSL: ", hsl);
    this.hueSlider = hsl.h * 240;
    this.satSlider = hsl.s * 240;
    this.lumSlider = (hsl.l * 240) < 60 ? 60 : ((hsl.l * 240) > 230 ? 230 : (hsl.l * 240));
    this.hslChange(1);
    this.app.broadcast({event: 'updateTextBox'});
    this.app.fireColorChangeEvent();
  }

  hslChange = (type: number = 0) => {
    if (this.originalCard === null) {
      let index = this.cardBackList.findIndex((c) => {
        return c.id === this.app.selectedCardBack.id;
      });
      this.originalCard = this.cardBackList[index];
    }
    // console.log("Hsl changed: ", this.hueSlider, this.satSlider, this.lumSlider);
    this.changeHsl(type, this.hueSlider / 240, this.satSlider / 240, this.lumSlider / 240);
    this.app.selectedCardBack.updateWheels = true;
    // this.setupColorWheels(this.app.selectedCardBack);  //Uncommented for removing slider change
    this.setUpdatePreview(true);
  };

  changeHSL(type, canvas, hShift, sShift, lShift) {
    let count = 0;
    let prev = null;
    let origrgb = this.hexToRgb(this.app.selectedCardBack.main);
    let orighsl = this.rgbToHsl(origrgb.r, origrgb.g, origrgb.b);
    // console.log("Orig rgb: ", origrgb);
    // console.log("Orig hsl: ", orighsl);
    for (let i = 0; i < this.cbData.length; i += 4) {
      let red = this.cbOriginalData[i];
      let green = this.cbOriginalData[i + 1];
      let blue = this.cbOriginalData[i + 2];
      let alpha = this.cbOriginalData[i + 3];


      // skip transparent/semiTransparent pixels
      if (alpha < 230) {
        continue;
      }

      let hsl = this.rgbToHsl(red, green, blue);
      let newRgb = null;


      let newL = (hsl.l * 240) > 230 ? hsl.l : ((hsl.l / orighsl.l) * lShift);

      newRgb = this.hslToRgb(hShift, sShift, newL);

      // if (((hsl.l * 240) <= 60) || ((hsl.l * 240) >= 230)) {
      //
      // } else {
      //   newRgb = this.hslToRgb(hShift, sShift, lShift);
      // }

      // change redish pixels to the new color

      this.cbData[i] = newRgb.r;
      this.cbData[i + 1] = newRgb.g;
      this.cbData[i + 2] = newRgb.b;
      this.cbData[i + 3] = 255;
    }
    this.cbChangeCtx.putImageData(this.cbImgData, 0, 0);
    return canvas.toDataURL("image/png");
  }

  hslShift(type, canvas, hShift, sShift, lShift) {
    //THIS IS HERE FOR THE NEW COLOR CHANGE, NO SLIDERS
    this.changeHSL(type, canvas, hShift, sShift, lShift);

    // let count = 0;
    // let prev = null;
    // for(let i = 0; i < this.cbData.length; i += 4) {
    //   let red = this.cbOriginalData[i];
    //   let green = this.cbOriginalData[i+1];
    //   let blue = this.cbOriginalData[i+2];
    //   let alpha = this.cbOriginalData[i+3];
    //
    //   // skip transparent/semiTransparent pixels
    //   if(alpha<230){continue;}
    //
    //   let hsl = this.rgbToHsl(red,green,blue);
    //   let newRgb = null;
    //   if (((hsl.l * 240) <= 60) || ((hsl.l * 240) >= 230)) {
    //     newRgb = this.hslToRgb(hsl.h, hsl.s, hsl.l);
    //   } else {
    //     newRgb = this.hslToRgb(hShift, sShift, lShift);
    //   }
    //
    //   // change redish pixels to the new color
    //
    //   this.cbData[i] = newRgb.r;
    //   this.cbData[i+1] = newRgb.g;
    //   this.cbData[i+2] = newRgb.b;
    //   this.cbData[i+3] = 255;
    // }
    this.cbChangeCtx.putImageData(this.cbImgData, 0, 0);
    return canvas.toDataURL("image/png");
  }

  ////////////////////////
// Helper functions
//

  rgbToHsl(r, g, b) {
    r /= 255, g /= 255, b /= 255;
    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      let d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return ({h: h, s: s, l: l});
  }

  hslToRgb(h, s, l) {
    let r, g, b;
    if (s == 0) {
      r = g = b = l; // achromatic
    } else {
      let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      let p = 2 * l - q;
      r = this.hue2rgb(p, q, h + 1 / 3);
      g = this.hue2rgb(p, q, h);
      b = this.hue2rgb(p, q, h - 1 / 3);
    }
    return ({
      r: Math.round(r * 255),
      g: Math.round(g * 255),
      b: Math.round(b * 255),
    });
  }

  hue2rgb(p, q, t) {
    if (t < 0) {
      t += 1;
    }
    if (t > 1) {
      t -= 1;
    }
    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }
    if (t < 1 / 2) {
      return q;
    }
    if (t < 2 / 3) {
      return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
  }

  getEditBoxHeight() {
    // let width = window.innerWidth < 1400 ? "100%" : "100%";
    //     // let height = 900;
    //     // return {'height': height + 'px'};
    return {'height': '100%'};
  }

  setCardUpForEditing(card) {
    console.log("Card to set up for editing: ", card);
    console.log("Sel saved card: ", this.app.selectedSavedCard, " Sel card back: ", this.app.selectedCardBack);
    if (!card.card_data) {
      this.app.getUploadedImage(card.id).subscribe((data) => {
        console.log("Has Card back bytes");
        let bytes = "data:image/jpg;base64," + data;
        card.card_data = bytes;
        setTimeout(() => {
          this.finishEditSetup(card, bytes);
        });
      }, (error) => {
        // console.log("Card bytes error: ", error);
        alert("There was an issue retrieving your image from the server");
      });
    } else {
      setTimeout(() => {
        this.finishEditSetup(card, card.card_data);
      });
    }
  }

  zeroPad(val: string) {
    if (val.length === 1) {
      return '0' + val;
    } else {
      return val;
    }
  }

  finishEditSetup(card, cardData) {
    // let cardData = this.app.getImageCookie(card.id);
    // if (!cardData) {
    //   cardData = '/assets/Blank Image.jpg';
    //   this.drawCanvasDefer = () => {
    //     this.changeImage();
    //   };
    // }
    let index = this.cardBackList.findIndex((c) => {
      return c.id === card.card_back;
    });
    let selCard = this.cardBackList[index];
    // console.log("Here at card clicked", selCard);
    this.cardBackClicked(selCard, true, false);
    let rgb = this.hslToRgb(card.hue / 240, card.saturation / 240, card.luminosity / 240);
    console.log("RGB: ", rgb);
    this.cardBackColor = "#" + this.zeroPad(rgb.r.toString(16)) + "" + this.zeroPad(rgb.g.toString(16)) + "" + this.zeroPad(rgb.b.toString(16)) + "";
    console.log("Card back color: ", this.cardBackColor);
    $('#cardColor').val(this.cardBackColor);
    this.hueSlider = card.hue;
    this.satSlider = card.saturation;
    this.lumSlider = card.luminosity;
    this.app.backgroundColor = card.background_color;
    this.app.images = [];
    let heightRatio = this.canvasHeight / card.height;
    let widthRatio = this.canvasWidth / card.width;
    // console.log("Curr canvas height: ", this.canvasHeight, " Card height: ", card.height);
    // console.log("Curr canvas width: ", this.canvasWidth, " Card width: ", card.width);
    if (true) {
      this.setupNewImage(0, "image", cardData, true, true, card.image_size_width * widthRatio,
        card.image_size_height * heightRatio, card.image_pos_x * widthRatio, card.image_pos_y * heightRatio, false, null);
    }
    this.app.selectedImage = this.app.images[0];
    // console.log("Images: ", this.app.images);
    card.text_items.forEach((t) => {
      this.setupNewImage(this.app.images.length, "text", '', false, false, 200,
        200, Math.floor(t.font_pos_x * widthRatio), Math.floor(t.font_pos_y * heightRatio), false,
        {text: t.text, fontSize: t.font_size, font: t.font, color: t.font_color});
    });
    this.app.hasImageAdded = true;
    if (this.cardBackColor !== "#ffffff") {
      this.hslChange();
    }
    setTimeout(() => {
      this.drawPreviewCanvas();
      setTimeout(() => {
        $('#canvasContainer').click();
      }, 300);
    }, 300);
  }

  displayTest() {
    // console.log("Card back color test: ", this.cardBackColor);
  }

  usingClickPixelForColor() {
    this.app.clickPixelForColor = !this.app.clickPixelForColor;
  }

  runCropImage() {
    // console.log("Got to broadcast crop image: ", this.app.selectedImage);
    let canvas: any = document.getElementById('imageCropper');
    let group = this.app.selectedImage.groupSave;
    let topLeft = this.itemWithResize.TLCAnchor;
    let bottomRight = this.itemWithResize.BRCAnchor;

    canvas.width = this.app.selectedImage.width;
    canvas.height = this.app.selectedImage.height;
    // console.log("Canvas: ", canvas);
    let context: any = canvas.getContext('2d');
    context.width = this.app.selectedImage.width;
    context.height = this.app.selectedImage.height;
    // console.log("Context: ", context);
    let imageObj = new Image();

    imageObj.onload = () => {
      // console.log("In onload");
      // draw cropped image
      var half = this.cropCornersSize / 2;
      let sourceX = topLeft.getX() + half;
      let sourceY = topLeft.getY() + half;
      let sourceWidth = bottomRight.getX() - topLeft.getX();
      let sourceHeight = bottomRight.getY() - topLeft.getY();
      // console.log("Source X: ", sourceX, " Source Y: ", sourceY);
      // console.log("Source width: ", sourceWidth, " Source height: ", sourceHeight);
      let destWidth = this.app.selectedImage.width;
      let destHeight = this.app.selectedImage.height;
      // console.log("DestWidth: " + this.app.selectedImage.width + " DestHeight: " + this.app.selectedImage.height + "");
      let destX = 0;
      let destY = 0;
      // console.log("Width: " + imageObj.width + " Height: " + imageObj.height + "");

      let ratioX = imageObj.width / this.app.selectedImage.width;
      let ratioY = imageObj.height / this.app.selectedImage.height;
      let x = sourceX * ratioX;
      let y = sourceY * ratioY;
      let width = sourceWidth * ratioX;
      let height = sourceHeight * ratioY;

      context.drawImage(imageObj, x, y, width, height, destX, destY, destWidth, destHeight);
      this.app.selectedImage.src = canvas.toDataURL();
      this.app.selectedImage.width = bottomRight.getX() - topLeft.getX();
      this.app.selectedImage.height = bottomRight.getY() - topLeft.getY();
      this.app.selectedImage.x = this.app.selectedImage.x + topLeft.getX() + half;
      this.app.selectedImage.y = this.app.selectedImage.y + topLeft.getY() + half;
      setTimeout(() => {
        this.editTabChanged(9);
        this.setUpdatePreview();
      });
    };
    // imageObj.height = this.app.selectedImage.height;
    // imageObj.width = this.app.selectedImage.width;
    imageObj.src = this.app.selectedImage.src;

  }

  editTabChanged = (val) => {
    console.log("At edit tab changed: ", val);
    this.inFormatMode = false;
    this.inCropMode = false;
    if (val === 1) {
      this.showBackOptions = true;
    }
    if (val !== 5) {
      this.app.images.forEach((i) => {
        i.draggable = false;
        i.resizable = false;
        if (val === 9 && i.type === 'image') {
          this.app.selectedImage = i;
        }
      });
      if (val === 7) {
        if (this.app.selectedImage.type !== "text") {
          this.app.selectedImage = this.app.images.find((t) => {
            return t.type === "text";
          });
        }
        this.app.selectedImage.draggable = true;
        this.app.selectedImage.resizable = true;
        this.inFormatMode = true;
      }
      if (val === 9) {
        this.app.selectedImage.draggable = true;
        this.app.selectedImage.resizable = true;
        this.inCropMode = true;
      }
    } else {
      console.log("App images: ", this.app.images);
      this.app.images.forEach((i) => {
        if (i.type === "image") {
          i.draggable = true;
          i.resizable = true;
          this.app.selectedImage = i;
        } else {
          i.draggable = false;
          i.resizable = false;
        }
      });
      this.inFormatMode = true;
    }
    this.drawPreviewCanvas();
  }

  broadCastHandle = (value: Object): void => {
    switch (value['event']) {
      case 'editCard':
        //This needs a delay due to a new handler being made
        console.log("In edit card");
        setTimeout(() => {
          value['event'] = 'finalizeEditCard';
          this.app.broadcast(value);
        }, 1500);
        break;
      case 'finalizeEditCard':
        console.log("In finalize card");
        let card = value['data'];
        // console.log("Here at edit card");
        setTimeout(() => {
          this.setCardUpForEditing(card);
        }, 300);
        break;
      case 'setUpdatePreview':
        this.setUpdatePreview();
        break;
      case 'addImage':
        this.addImage();
        break;
      case 'addTextImage':
        this.addTextImage();
        break;
      case 'imageClicked':
        this.imageClicked(value['data']);
        break;
      case 'updateFont':
        this.updateFont(value['data']);
        break;
      case 'updateTextBox':
        this.updateTextBox();
        break;
      case 'removeImage':
        this.removeImage();
        break;
      case 'createNewCard':
        this.createNewCard();
        break;
      case 'finishCreateNewCard':
        this.finishCreateNewCard();
        break;
      case 'overwriteCard':
        this.overwriteCard();
        break;
      case 'finishOverwrite':
        this.finishOverwrite();
        break;
      case 'editTabChanged':
        let val = value['data'];
        this.editTabChanged(val);
        break;
      case 'cropImage':
        setTimeout(() => {
          this.runCropImage();
        });
        break;
      default:
        break;
    }
  }
}
